import React, { useContext, useState, useCallback, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import { Grid, Typography, Card, IconButton, Tooltip } from "@material-ui/core";
import { MdPrint } from "react-icons/md";
import ResizeDetector from "react-resize-detector";
import { LangContext } from "../../Context/Langcontext";
import THBText from "thai-baht-text";
import { getUsageStat } from "../../API/Usage";
import useReactRouter from "use-react-router";
import moment from "moment";
import Barcode from "react-barcode";
import { saveAs } from "file-saver";
import {
  Document,
  Media,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  AlignmentType,
  Footer,
  TextRun,
  TabStopType,
  TabStopPosition,
  WidthType,
  HeightRule,
  BorderStyle,
  ShadingType,
  HeadingLevel,
} from "docx";
import { getUserOne } from "../../API/User";

moment.locale("th");

const useStyle = makeStyles((theme) => ({
  root: {
    width: "210mm",
    backgroundColor: "#FFFFFF",
    minHeight: "297mm",
    padding: 20,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    marginTop: "-2rem",
  },
  top: {
    paddingBottom: 20,
    width: "100%",
    textAlign: "center",
  },
  right: {
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column",
  },
  detailinvoice: {
    textAlign: "right",
  },
  left: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  contentleft: {
    textAlign: "left",
  },
  grid: {
    marginBottom: 20,
  },
  text: {
    fontWeight: 200,
    fontFamily: "Sarabun",
  },
  total: {
    textAlign: "right",
    borderTop: "1px solid #eee",
    borderBottom: "1px solid #eee",
  },
  leftitem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginBottom: 5,
  },
  rightitem: {
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column",
    marginBottom: 5,
  },
  textcomp: {
    fontWeight: 400,
    fontSize: "0.8rem",
    fontFamily: "Sarabun",
  },
  totaltext: {
    fontWeight: 700,
    fontSize: "0.8rem",
    fontFamily: "Sarabun",
  },
  footer: {
    width: "210mm",
    borderTop: "1px solid #eee",
    paddingTop: 20,
  },
  cardapi: {
    width: "100%",
    backgroundColor: "lightgrey",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",

    minHeight: "-webkit-fill-available",
    maxHeight: "100%",
  },
  headcenter: {
    textAlign: "center",
    borderTop: "1px solid #000000",
    borderLeft: "1px solid #000000",
    borderBottom: "1px solid #000000",
  },
  body: {
    borderLeft: "1px solid #000000",
    borderBottom: "1px solid #000000",
    height: 150,
  },
}));
const Invoice = () => {
  const classes = useStyle();
  const [load, setload] = useState(false);
  const { match } = useReactRouter();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const [data, setData] = useState({
    name: "",
    address: "",
    province: "",
    amphoe: "",
    tambon: "",
    zipcode: "",
  });
  const [state, setstate] = useState({
    sum_cost: 0,
    sum_net: 0,
    sum_req_err: 0,
    sum_request: 0,
    sum_size: 0,
    sum_vat: 0,
  });

  const exportPDF = async () => {
    const doc = new Document({
      styles: {
        paragraphStyles: [
          {
            id: "Heading2",
            name: "Heading 2",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              size: 24,
              bold: false,
              font: { name: "Kanit" },
            },
            paragraph: {},
          },
        ],
      },
    });

    const blob = await fetch(
      "https://raw.githubusercontent.com/istick15/Apptest/master/MEA_new-1colorcenter.png"
    ).then((r) => r.blob());

    const blob2 = await fetch(
      "https://raw.githubusercontent.com/istick15/Apptest/master/ictmea.PNG"
    ).then((r) => r.blob());

    const blob3 = await fetch(
      "https://raw.githubusercontent.com/istick15/Apptest/master/barcode.PNG"
    ).then((r) => r.blob());

    const image1 = Media.addImage(doc, blob, 100, 75);
    const qrcode = Media.addImage(doc, blob2, 75, 75);
    const barcode = Media.addImage(doc, blob3, 325, 75);
    const text1 = new TextRun({
      text: `\t${"กรุณาส่ง"}`,
      bold: true,
      font: {
        name: "Kanit",
      },
      size: 24,
    });

    const tableHead = new Table({
      width: { size: 9000, type: WidthType.DXA },
      borders: {
        top: { style: BorderStyle.NONE },
        left: { style: BorderStyle.NONE },
        bottom: { style: BorderStyle.NONE },
        right: { style: BorderStyle.NONE },
      },
      rows: [
        new TableRow({
          children: [
            new TableCell({
              borders: {
                top: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                left: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                bottom: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                right: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
              },
              width: { size: 33.33, type: WidthType.PERCENTAGE },
              children: [
                new Paragraph({
                  text: "",
                }),
              ],
            }),
            new TableCell({
              borders: {
                top: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                left: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                bottom: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                right: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
              },
              width: { size: 33.33, type: WidthType.PERCENTAGE },
              children: [
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [image1],
                }),
              ],
            }),
            new TableCell({
              borders: {
                top: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                left: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                bottom: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                right: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
              },
              width: { size: 33.33, type: WidthType.PERCENTAGE },
              children: [
                new Paragraph({
                  text: "การไฟฟ้านครหลวง",
                  alignment: AlignmentType.LEFT,
                  heading: HeadingLevel.HEADING_2,
                }),
                new Paragraph({
                  text: "อาคารวัฒนวิภาส เลขที่ 1192 ถนนพระรามที่ 4",
                  alignment: AlignmentType.LEFT,
                  heading: HeadingLevel.HEADING_2,
                }),
                new Paragraph({
                  text: "แขวงคลองเตย เขตคลองเตย กรุงเทพมหานคร",
                  alignment: AlignmentType.LEFT,
                  heading: HeadingLevel.HEADING_2,
                }),
                new Paragraph({
                  text: "10110",
                  alignment: AlignmentType.LEFT,
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
          ],
        }),
      ],
    });

    const tableFooter = new Table({
      width: { type: WidthType.DXA },
      borders: {
        top: { style: BorderStyle.NONE },
        left: { style: BorderStyle.NONE },
        bottom: { style: BorderStyle.NONE },
        right: { style: BorderStyle.NONE },
      },
      rows: [
        new TableRow({
          children: [
            new TableCell({
              borders: {
                top: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                left: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                bottom: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                right: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
              },
              width: { size: 80, type: WidthType.PERCENTAGE },
              children: [
                new Paragraph({
                  text: "ฝ่ายวางแผนและบริหารทรัพย์สินเทคโนโลยี งานบริหารทรัพย์สินสารสนเทศ",
                  heading: HeadingLevel.HEADING_2,
                }),
                new Paragraph({
                  text: "883 อาคาร ICT ริมน้ำ ชั้น 5 แขวงราษฎร์บูรณะ แขวงราษฎร์บูรณะ กรุงเทพมหานคร 10140",
                  heading: HeadingLevel.HEADING_2,
                }),
                new Paragraph({
                  text: "โทร. 0-2442-2625-7 โทรสาร. 0-2442-2729",
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
            new TableCell({
              borders: {
                top: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                left: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                bottom: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
                right: { style: BorderStyle.DASHED, color: "ffffff", size: 1 },
              },
              width: { size: 20, type: WidthType.PERCENTAGE },
              children: [
                new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [qrcode],
                }),
              ],
            }),
          ],
        }),
      ],
    });

    const table = new Table({
      width: { size: 9000, type: WidthType.DXA },
      rows: [
        new TableRow({
          children: [
            new TableCell({
              shading: {
                fill: "cccccc",
                val: ShadingType.CLEAR,
              },
              children: [
                new Paragraph({
                  text: "รายการ",
                  alignment: AlignmentType.CENTER,
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
            new TableCell({
              shading: {
                fill: "cccccc",
                val: ShadingType.CLEAR,
              },
              children: [
                new Paragraph({
                  text: "จำนวน",
                  alignment: AlignmentType.CENTER,
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
            new TableCell({
              shading: {
                fill: "cccccc",
                val: ShadingType.CLEAR,
              },
              children: [
                new Paragraph({
                  text: "ราคาต่อหน่วย",
                  alignment: AlignmentType.CENTER,
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
            new TableCell({
              shading: {
                fill: "cccccc",
                val: ShadingType.CLEAR,
              },
              children: [
                new Paragraph({
                  text: "จำนวนเงิน",
                  alignment: AlignmentType.CENTER,
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
          ],
        }),
        new TableRow({
          height: { height: 2500, rule: HeightRule.ATLEAST },
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: "ค่าบริการการเรียกใช้ Data Service APIs และ Map Service APIs ผ่านทางระบบให้บริการข้อมูลแผนที่",
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: `${state.sum_request}`,
                  alignment: AlignmentType.CENTER,
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: `-`,
                  alignment: AlignmentType.CENTER,
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: `${state.sum_cost}`,
                  alignment: AlignmentType.CENTER,
                  heading: HeadingLevel.HEADING_2,
                }),
              ],
            }),
          ],
        }),
      ],
    });

    doc.addSection({
      children: [
        tableHead,

        new Paragraph({
          text: "",
        }),

        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: 1000,
            },
          ],
          children: [text1],
        }),
        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: 2000,
            },
          ],
          text: `\t${lang.Organization}  ${data.name ? data.name : "-"}`,
          alignment: AlignmentType.LEFT,
          heading: HeadingLevel.HEADING_2,
        }),
        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: 2000,
            },
          ],
          text: `\t${lang.Address} : ${data.address ? data.address : "-"}`,

          alignment: AlignmentType.LEFT,
          heading: HeadingLevel.HEADING_2,
        }),
        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: 2000,
            },
          ],
          text: `\t${lang.District} : ${data.amphoe ? data.amphoe : "-"}`,
          alignment: AlignmentType.LEFT,
          heading: HeadingLevel.HEADING_2,
        }),
        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: 2000,
            },
          ],
          text: `\t${lang.City}  ${data.province ? data.province : "-"}`,

          alignment: AlignmentType.LEFT,
          heading: HeadingLevel.HEADING_2,
        }),
        new Paragraph({
          text: "",
        }),
        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: 8280,
            },
          ],
          children: [
            new TextRun({
              text: `เลขที่เอกสาร : ${Math.floor(
                1000000000 + Math.random() * 9000000000
              )}`,
              bold: false,
              font: {
                name: "Kanit",
              },
              size: 24,
            }),
            new TextRun({
              text: `\tวันที่ : ${convertDate(moment(moment()).format("LL"))}`, //`\tวันที่ : ${convertDate(new Date())}`,
              bold: false,
              font: {
                name: "Kanit",
              },
              size: 24,
            }),
          ],
        }),
        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: 7000,
            },
          ],
          children: [
            new TextRun({
              text: `บัญชีแสดงสัญญา : `,
              bold: false,
              font: {
                name: "Kanit",
              },
              size: 24,
            }),
            new TextRun({
              text: `\tเลขรับ : `,
              bold: false,
              font: {
                name: "Kanit",
              },
              size: 24,
            }),
          ],
        }),
        new Paragraph({
          text: `ชื่อ : ${data.name}`,
          heading: HeadingLevel.HEADING_2,
        }),
        new Paragraph({
          text: `ที่อยู่ : ${
            data.address
              ? `${data.address} ${data.tambon} ${data.amphoe} ${data.zipcode}`
              : "-"
          }`,
          heading: HeadingLevel.HEADING_2,
        }),
        new Paragraph({
          text: "",
        }),

        table,

        new Paragraph({
          text: "",
        }),

        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: TabStopPosition.MAX,
            },
          ],
          children: [
            new TextRun({
              text: `\tรวมเงิน           ${state.sum_cost} บาท`,
              font: {
                name: "Kanit",
              },
              size: 24,
            }),
          ],
        }),
        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: TabStopPosition.MAX,
            },
          ],
          children: [
            new TextRun({
              text: `\tภาษีมูลค่าเพิ่ม 7 %           ${state.sum_vat} บาท`,
              font: {
                name: "Kanit",
              },
              size: 24,
            }),
          ],
        }),
        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: TabStopPosition.MAX,
            },
          ],
          children: [
            new TextRun({
              text: `\tรวมเงินทั้งสิ้น           ${state.sum_net} บาท`,
              font: {
                name: "Kanit",
              },
              size: 24,
            }),
          ],
        }),
        new Paragraph({
          tabStops: [
            {
              type: TabStopType.RIGHT,
              position: TabStopPosition.MAX,
            },
          ],
          children: [
            new TextRun({
              text: `\t(${THBText(state.sum_net)})`,
              font: {
                name: "Kanit",
              },
              size: 24,
            }),
          ],
        }),
        new Paragraph({
          text: "",
        }),
        new Paragraph({
          text: `โปรดติดต่อชำระเงินได้ที่การไฟฟ้านครหลวงทุกแห่งภายในวันที่ ${convertDate(
            moment(moment(moment().add(14, "days"))).format("LL")
          )} กรณีชำระโดยเช็คโปรดจ่ายเช็คขีดคร่อมสั่งจ่ายในนามการไฟฟ้านครหลวงเข้าบัญชีผู้รับเงินเท่านั้น และขีดฆ่าคำว่า "หรือผู้ถือ"`,
          heading: HeadingLevel.HEADING_2,
        }),
        new Paragraph({
          text: '"การไฟฟ้านครหลวงมิได้เป็นนิติบุคคลตามมาตรา 39 แห่งประมวลรัษฎากรจึงไม่ต้องถูกหักภาษีเงินได้ ณ ที่จ่าย"',
          heading: HeadingLevel.HEADING_2,
        }),
        new Paragraph({
          text: "",
        }),
        new Paragraph({
          children: [barcode],
          alignment: AlignmentType.CENTER,
        }),
      ],
      footers: {
        default: new Footer({
          children: [tableFooter],
        }),
      },
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, `mea_invoice.docx`);
    });
    // const input = document.getElementById("invoice");
    // const canvas = await html2canvas(input);
    // const imgData = canvas.toDataURL("image/png");

    // var doc = new jsPDF("p", "mm");
    // var position = 0;
    // var imgWidth = 210;
    // var pageHeight = 295;
    // var imgHeight = Number(canvas.height * imgWidth) / canvas.width;

    // var heightLeft = imgHeight;
    // doc.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    // heightLeft -= pageHeight;

    // while (heightLeft >= 0) {
    //   position = heightLeft - imgHeight;
    //   doc.addPage();
    //   doc.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    //   heightLeft -= pageHeight;
    // }
    // doc.save("invoice.pdf");
  };

  const convertDate = (d) => {
    const monthNames = [
      lang.January,
      lang.February,
      lang.March,
      lang.April,
      lang.May,
      lang.June,
      lang.July,
      lang.August,
      lang.September,
      lang.October,
      lang.November,
      lang.December,
    ];

    let dateObj = new Date(d);
    let month = monthNames[dateObj.getMonth()];
    let day = String(dateObj.getDate());
    let year = dateObj.getFullYear();

    let output = `${day} ${month} ${
      langContext.lang.locale === "th" ? Number(year + 543) : year
    }`;
    return output;
  };

  const getData = useCallback(async () => {
    const get = await getUsageStat(`/aggregate?user_id=${match.params.id}`);
    const user_one = await getUserOne(match.params.id);

    if (user_one.status.code === 200) {
      setData({
        ...state,
        name: user_one.data[0].organization
          ? user_one.data[0].organization
          : "-",
        address: user_one.data[0].address ? user_one.data[0].address : "-",
        amphoe: user_one.data[0].amphoe ? user_one.data[0].amphoe : "-",
        province: user_one.data[0].province ? user_one.data[0].province : "-",
        tambon: user_one.data[0].tambon ? user_one.data[0].tambon : "-",
        zipcode: user_one.data[0].zipcode ? user_one.data[0].zipcode : "-",
      });
    }
    if (get.status.code === 200 && get.data.length !== 0) {
      setstate({
        sum_cost: get.data[0].sum_cost,
        sum_net: get.data[0].sum_net,
        sum_req_err: get.data[0].sum_req_err,
        sum_request: get.data[0].sum_request,
        sum_size: get.data[0].sum_size,
        sum_vat: get.data[0].sum_vat,
      });
    }
  }, [match]);

  useEffect(() => {
    if (!load) {
      getData();
      setload(true);
    } else {
    }
  }, [load, getData]);

  return (
    <Card className={classes.cardapi}>
      <ResizeDetector
        handleWidth
        handleHeight
        render={({ width, height }) => (
          <div
            style={{
              width: width,
              textAlign: "right",
            }}
          >
            <Tooltip title={`${lang.Export} Word`} placement="top">
              <IconButton onClick={exportPDF}>
                <MdPrint size={30} />
              </IconButton>
            </Tooltip>
          </div>
        )}
      />
      <div className={classes.root} id="invoice">
        <div>
          <Grid container alignItems="center" className={classes.grid}>
            <Grid item xs={4} className={classes.left}></Grid>
            <Grid
              item
              xs={4}
              className={classes.left}
              style={{ alignItems: "center" }}
            >
              <img
                alt=""
                src={require("../../images/LOGO/MEA_new-1colorcenter.png")}
                style={{ width: "6rem", height: "auto" }}
              />
            </Grid>
            <Grid item xs={4} className={classes.right}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp}>
                  การไฟฟ้านครหลวง
                </Typography>
                <Typography className={classes.textcomp}>
                  อาคารวัฒนวิภาส เลขที่ 1192 ถนนพระรามที่ 4
                </Typography>
                <Typography className={classes.textcomp}>
                  แขวงคลองเตย เขตคลองเตย กรุงเทพมหานคร
                </Typography>
                <Typography className={classes.textcomp}>10110</Typography>
              </div>
            </Grid>
          </Grid>
          <Grid container alignItems="center" className={classes.grid}>
            <Grid item xs={12} className={classes.left}>
              <div className={classes.contentleft}>
                <Typography className={classes.totaltext}>กรุณาส่ง</Typography>
                <Typography className={classes.textcomp}>
                  {`${lang.Organization} : ${data.name}`}
                </Typography>
                <Typography className={classes.textcomp}>
                  {`${lang.Address} : ${data.address ? data.address : "-"}`}
                </Typography>
                <Typography className={classes.textcomp}>
                  {`${lang.District} : ${data.amphoe ? data.amphoe : "-"}`}
                </Typography>
                <Typography className={classes.textcomp}>
                  {`${lang.City} : ${data.province ? data.province : "-"}`}
                </Typography>
              </div>
            </Grid>
          </Grid>
          <Grid container alignItems="center" className={classes.grid}>
            <Grid item xs={6} className={classes.left}>
              <div style={{ display: "flex" }}>
                <Typography
                  className={classes.totaltext}
                  style={{ marginRight: "0.2rem" }}
                >{`เลขที่เอกสาร : `}</Typography>
                <Typography className={classes.textcomp}>
                  {Math.floor(1000000000 + Math.random() * 9000000000)}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={6} className={classes.left}>
              <div style={{ display: "flex" }}>
                <Typography
                  className={classes.totaltext}
                  style={{ marginRight: "0.2rem" }}
                >{`วันที่ : `}</Typography>
                <Typography className={classes.textcomp}>
                  {convertDate(new Date())}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={6} className={classes.left}>
              <div style={{ display: "flex" }}>
                <Typography
                  className={classes.totaltext}
                  style={{ marginRight: "0.2rem" }}
                >{`บัญชีแสดงสัญญา : `}</Typography>
                <Typography className={classes.textcomp}></Typography>
              </div>
            </Grid>
            <Grid item xs={6} className={classes.left}>
              <div style={{ display: "flex" }}>
                <Typography
                  className={classes.totaltext}
                  style={{ marginRight: "0.2rem" }}
                >{`เลขรับ : `}</Typography>
                <Typography className={classes.textcomp}></Typography>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.left}>
              <div style={{ display: "flex" }}>
                <Typography
                  className={classes.totaltext}
                  style={{ marginRight: "0.2rem" }}
                >{`ชื่อ : `}</Typography>
                <Typography className={classes.textcomp}>
                  {data.name ? data.name : "-"}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.left}>
              <div style={{ display: "flex" }}>
                <Typography
                  className={classes.totaltext}
                  style={{ marginRight: "0.2rem" }}
                >{`ที่อยู่ : `}</Typography>
                <Typography className={classes.textcomp}>
                  {data.address
                    ? `${data.address} ${data.tambon} ${data.amphoe} ${data.zipcode}`
                    : "-"}
                  {/* {user.billing_info
                    ? user.billing_info === undefined
                      ? "-"
                      : user.billing_info.address === ""
                      ? `-`
                      : user.billing_info.address
                    : "-"} */}
                </Typography>
              </div>
            </Grid>
          </Grid>
          <div style={{ marginTop: "5rem" }} />
          <Grid
            container
            alignItems="center"
            style={{ backgroundColor: "lightgray" }}
          >
            <Grid item xs={8} className={classes.headcenter}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp} align="center">
                  รายการ
                </Typography>
              </div>
            </Grid>
            <Grid item xs={1} className={classes.headcenter}>
              <div className={classes.detailinvoice}>
                <Typography className={classes.textcomp} align="center">
                  จำนวน
                </Typography>
              </div>
            </Grid>
            <Grid item xs={2} className={classes.headcenter}>
              <div className={classes.detailinvoice}>
                <Typography className={classes.textcomp} align="center">
                  ราคาต่อหน่วย
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              xs={1}
              className={classes.headcenter}
              style={{ borderRight: "1px solid #000000" }}
            >
              <div className={classes.detailinvoice}>
                <Typography className={classes.textcomp} align="center">
                  จำนวนเงิน
                </Typography>
              </div>
            </Grid>
          </Grid>

          <Grid container alignItems="center" className={classes.grid}>
            <Grid item xs={8} className={classes.body}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp} style={{ padding: 5 }}>
                  ค่าบริการการเรียกใช้ Data Service APIs และ Map Service APIs
                  ผ่านทางระบบให้บริการข้อมูลแผนที่
                </Typography>
              </div>
            </Grid>
            <Grid item xs={1} className={classes.body}>
              <div className={classes.detailinvoice}>
                <Typography
                  className={classes.textcomp}
                  align="center"
                  style={{ padding: 5 }}
                >
                  {state.sum_request}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={2} className={classes.body}>
              <div className={classes.detailinvoice}>
                <Typography
                  className={classes.textcomp}
                  align="center"
                  style={{ padding: 5 }}
                >
                  -
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              xs={1}
              className={classes.body}
              style={{ borderRight: "1px solid #000000" }}
            >
              <div className={classes.detailinvoice}>
                <Typography
                  className={classes.textcomp}
                  align="right"
                  style={{ padding: 5 }}
                >
                  {`${state.sum_cost.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
                </Typography>
              </div>
            </Grid>
          </Grid>

          <Grid container alignItems="center" className={classes.grid}>
            <Grid item xs={8}></Grid>
            <Grid item xs={2}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp} align="left">
                  รวมเงิน
                </Typography>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp} align="right">
                  {`${state.sum_cost.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })} บาท`}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={8}></Grid>
            <Grid item xs={2}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp} align="left">
                  ภาษีมูลค่าเพิ่ม 7 %
                </Typography>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp} align="right">
                  {`${state.sum_vat.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })} บาท`}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={8}></Grid>
            <Grid item xs={2}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp} align="left">
                  รวมเงินทั้งสิ้น
                </Typography>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp} align="right">
                  {`${state.sum_net.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })} บาท`}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp} align="right">
                  {`(${THBText(state.sum_net)})`}
                </Typography>
              </div>
            </Grid>
          </Grid>

          <Grid container alignItems="center" className={classes.grid}>
            <Grid item xs={12} className={classes.leftitem}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp}>
                  {/* {convertDate(new Date().setDate(new Date().getDate() - 30))} */}
                  {`โปรดติดต่อชำระเงินได้ที่การไฟฟ้านครหลวงทุกแห่งภายในวันที่ ${convertDate(
                    moment(moment(moment().add(14, "days"))).format("LL")
                  )} กรณีชำระโดยเช็คโปรดจ่ายเช็คขีดคร่อมสั่งจ่ายในนามการไฟฟ้านครหลวงเข้าบัญชีผู้รับเงินเท่านั้น และขีดฆ่าคำว่า "หรือผู้ถือ"`}
                </Typography>
                <Typography className={classes.textcomp}>
                  {`"การไฟฟ้านครหลวงมิได้เป็นนิติบุคคลตามมาตรา 39
                  แห่งประมวลรัษฎากรจึงไม่ต้องถูกหักภาษีเงินได้ ณ ที่จ่าย"`}
                </Typography>
              </div>
            </Grid>
          </Grid>
          <Grid container alignItems="center" className={classes.grid}>
            <Grid
              item
              xs={12}
              className={classes.leftitem}
              style={{ alignItems: "center" }}
            >
              <div>
                <Barcode
                  value="123456789012"
                  width={1.5}
                  fontSize={16}
                  height={80}
                  format="CODE39"
                />
              </div>
            </Grid>
          </Grid>
        </div>

        <div className={classes.footer}>
          <Grid container alignItems="center">
            <Grid item xs={6}>
              <div className={classes.contentleft}>
                <Typography className={classes.textcomp}>
                  ฝ่ายวางแผนและบริหารทรัพย์สินเทคโนโลยี
                  งานบริหารทรัพย์สินสารสนเทศ
                </Typography>
                <Typography className={classes.textcomp}>
                  883 อาคาร ICT ริมน้ำ ชั้น 5 แขวงราษฎร์บูรณะ แขวงราษฎร์บูรณะ
                  กรุงเทพมหานคร 10140
                </Typography>
                <Typography className={classes.textcomp}>
                  โทร. 0-2442-2625-7 โทรสาร. 0-2442-2729
                </Typography>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.detailinvoice}>
                <img
                  alt="qr"
                  src={require("../../images/graphic-icon/ictmea.PNG")}
                  style={{ width: "4.5rem", height: "auto" }}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Card>
  );
};

export default Invoice;
